import { Grid, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { Meta } from "@/shared/components";
import { useDashboardQuery } from "@/partner/entities/analytics";
import { DashboardMetrics } from "@/partner/features/dashboard/ui/DashboardMetrics";
import { DashboardContentMetrics } from "@/partner/features/dashboard/ui/DashboardContentMetrics";
import { StreamingUsageCard } from "@/partner/features/dashboard/ui/StreamingUsageCard";
import {
  UnpaidInvoicesCard,
  useUnpaidInvoicesSummary,
} from "@/partner/features/billing";
import { SupportRequestsDashboard } from "@/partner/features/supportRequests";
import { useAbility } from "@/partner/shared/lib";

// Референс (Rightholder/Dashboard/Dashboard.js) не рендерит видимый
// page-заголовок — CardHeader с title там закомментирован; <Meta> ниже
// выставляет только document.title (вкладка браузера), не UI-элемент.
export const DashboardPage = () => {
  const { t } = useTranslation();
  const unpaidInvoices = useUnpaidInvoicesSummary();
  // Тот же гейт, что у пункта меню «Обращения» (read SupportRequest).
  const canReadRequests = useAbility().can("read", "SupportRequest");

  const { data } = useDashboardQuery({
    variables: {
      dateFrom: moment().subtract(1, "week").startOf("day").toISOString(),
      dateTo: moment().endOf("day").toISOString(),
    },
  });

  return (
    <>
      <Meta title={t("dashboard.pageTitle")} pageType="Partner" />

      <Grid container spacing={1}>
        {/* Пустой Grid-элемент дал бы лишний отступ, поэтому элемент
            появляется только вместе с карточкой. */}
        {unpaidInvoices && (
          <Grid size={12}>
            <UnpaidInvoicesCard summary={unpaidInvoices} />
          </Grid>
        )}
        {/* Две независимые колонки, а не строки сетки: высота карточки
            справа (Cloudflare Stream) не оставляет дыру под короткой
            карточкой слева. На мобильном колонки идут одна за другой. */}
        <Grid size={{ xs: 12, md: 6 }}>
          <Stack spacing={1}>
            {data?.dashboard && (
              <DashboardMetrics metrics={data.dashboard.metrics} />
            )}
            {canReadRequests && <SupportRequestsDashboard />}
          </Stack>
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <Stack spacing={1}>
            {data?.dashboard && (
              <DashboardContentMetrics dashboard={data.dashboard} />
            )}
            <StreamingUsageCard />
          </Stack>
        </Grid>
      </Grid>
    </>
  );
};
